// extracted by mini-css-extract-plugin
module.exports = {"modal":"pV","modalContent":"qV","modalOverlay":"rV","copy":"sV","modalBtnContainer":"tV","btnStay":"uV","disabled":"vV","btnContinue":"wV"};